import HelperMixin from '../../Shared/HelperMixin.vue';
import PaginationHelper from '../../Shared/PaginationHelper.vue';
import { printSurplusRequest } from './printSurplusRequest';

export default {
    name: 'SurplusRequests',
    mixins: [HelperMixin],
    components: { PaginationHelper },

    async created() {
        await this.CheckLoginStatus();
        if (!this.loginDetails || !this.canViewSurplusRequestsUi()) {
            this.logout();
            return;
        }
        this.GetInfo();
        if (this.isFacilityUser) {
            this.loadProducts();
        }
        if (this.isMinistryUser) {
            this.loadBranches();
        }
    },

    computed: {
        isMinistryUser() {
            return this.canReviewProcurementRequestsUi();
        },
        isFacilityUser() {
            return this.canCreateSurplusRequestsUi();
        },
        statsCards() {
            return [
                this.statCard('إجمالي طلبات الفائض', this.pages, 'primary', 'ti ti-packages'),
                this.statCard('طلبات مقدمة', this.countWhere(this.Info, item => this.matchStatus(item, [1], ['مقد'])), 'warning', 'ti ti-send'),
                this.statCard('موجّهة للتدوير', this.countWhere(this.Info, item => this.matchStatus(item, [2], ['تدوير'])), 'info', 'ti ti-refresh'),
                this.statCard('طلبات مرفوضة', this.countWhere(this.Info, item => this.matchStatus(item, [3], ['مرفوض'])), 'danger', 'ti ti-ban'),
            ];
        }
    },

    data() {
        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            Search: '',
            statusFilter: 0,
            Info: [],
            detail: null,
            detailDialog: false,
            createDialog: false,
            reviewDialog: false,
            products: [],
            branches: [],
            createForm: {
                productsId: null,
                quantity: 1,
                note: ''
            },
            reviewForm: {
                id: 0,
                approve: true,
                rotationTargetBranchesId: null,
                note: ''
            }
        };
    },

    methods: {
        statusBadgeClass(status) {
            const normalizedStatus = Number(status);
            if (normalizedStatus === 2) return 'bg-label-success';
            if (normalizedStatus === 3) return 'bg-label-danger';
            if (normalizedStatus === 1) return 'bg-label-warning';
            return 'bg-label-secondary';
        },
        statusLabel(status) {
            const normalizedStatus = Number(status);
            if (normalizedStatus === 1) return 'مقدّم';
            if (normalizedStatus === 2) return 'موجّه للتدوير';
            if (normalizedStatus === 3) return 'مرفوض';
            return '-';
        },
        requestCode(item) {
            if (!item) return '-';
            return item.code || item.requestCode || `SUR-${item.id}`;
        },
        requestMetaText(item) {
            if (!item) return 'بدون ملاحظات';
            return item.note || `إجمالي الكمية ${item.quantity || 0}`;
        },
        targetBranchMetaText(item) {
            if (!item || !item.targetBranchName) {
                return 'لم يتم تحديد مرفق مستهدف بعد';
            }
            return Number(item.status) === 2 ? 'تم التوجيه للتدوير' : 'مرفق مقترح للتوجيه';
        },
        approvalDecisionBadgeClass(decisionLabel) {
            const value = String(decisionLabel || '').trim();
            if (!value) return 'bg-label-secondary';
            if (value.includes('رفض')) return 'bg-label-danger';
            if (value.includes('اعتمد') || value.includes('موافق')) return 'bg-label-success';
            if (value.includes('معل')) return 'bg-label-warning';
            return 'bg-label-primary';
        },
        GetInfo(pageNo) {
            this.pageNo = pageNo || 1;
            this.$blockUI.Start();
            this.$http.GetSurplusRequests(this.pageNo, this.pageSize, this.Search, this.statusFilter)
                .then((response) => {
                    this.$blockUI.Stop();
                    this.Info = response.data.info || [];
                    this.pages = response.data.count || 0;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                    this.Info = [];
                    this.pages = 0;
                });
        },
        loadProducts() {
            this.$http.GetAllProducts()
                .then((response) => {
                    this.products = response.data.info || response.data || [];
                })
                .catch(() => {
                    this.products = [];
                });
        },
        loadBranches() {
            this.$http.GetAllBranches()
                .then((response) => {
                    this.branches = response.data.info || response.data || [];
                })
                .catch(() => {
                    this.branches = [];
                });
        },
        openCreateDialog() {
            this.createForm = { productsId: null, quantity: 1, note: '' };
            this.createDialog = true;
        },
        submitCreate() {
            this.$blockUI.Start();
            this.$http.CreateSurplusRequest(this.createForm)
                .then((response) => {
                    this.$blockUI.Stop();
                    this.$helper.ShowMessage('success', 'تم', response.data.message || 'تم إرسال الطلب.');
                    this.createDialog = false;
                    this.GetInfo(1);
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    const msg = err.response && err.response.data ? err.response.data : 'خطأ';
                    this.$helper.ShowMessage('error', 'خطأ', msg);
                });
        },
        openDetail(item) {
            this.$blockUI.Start();
            this.$http.GetSurplusRequest(item.id)
                .then((response) => {
                    this.$blockUI.Stop();
                    this.detail = response.data.info;
                    this.detailDialog = true;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                });
        },
        openReview(approve) {
            if (!this.detail) return;
            this.reviewForm = {
                id: this.detail.id,
                approve,
                rotationTargetBranchesId: this.detail.rotationTargetBranchesId || null,
                note: ''
            };
            this.reviewDialog = true;
        },
        submitReview() {
            this.$blockUI.Start();
            this.$http.ReviewSurplusRequest(this.reviewForm)
                .then((response) => {
                    this.$blockUI.Stop();
                    this.$helper.ShowMessage('success', 'تم', response.data);
                    this.reviewDialog = false;
                    this.detailDialog = false;
                    this.detail = null;
                    this.GetInfo(this.pageNo);
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    const msg = err.response && err.response.data ? err.response.data : 'خطأ';
                    this.$helper.ShowMessage('error', 'خطأ', msg);
                });
        },
        printDetail() {
            if (!this.detail || !this.detail.canPrint) return;
            this.$http.MarkSurplusRequestPrinted(this.detail.id)
                .then(() => {
                    const opened = printSurplusRequest(this.detail);
                    if (!opened) {
                        this.$helper.ShowMessage('warning', 'تنبيه', 'تعذر فتح نافذة الطباعة.');
                        return;
                    }
                    this.openDetail({ id: this.detail.id });
                })
                .catch((err) => {
                    const msg = err.response && err.response.data ? err.response.data : 'تعذر تسجيل الطباعة.';
                    this.$helper.ShowMessage('error', 'خطأ', msg);
                });
        }
    }
};
